import { configureStore } from "@reduxjs/toolkit";
import cart from "./cartSlice";

const store = configureStore({ reducer: { cart } });

// Persist to localStorage
store.subscribe(() => {
  const { cart } = store.getState();
  localStorage.setItem("cart", JSON.stringify(cart));
});

export default store;
